import { Button, DatePicker, Divider, Form, Input, InputNumber, Select, message, Upload, Radio, Skeleton, Alert, Modal } from 'antd'
import { DeleteOutlined, LoadingOutlined, PaperClipOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons'
import React, { useContext, useEffect, useRef, useState } from 'react'
import dayjs from 'dayjs';
import RecentPhotos from './RecentPhoto';
import { useNavigate } from 'react-router-dom';
import { isoFormatDate } from '../../Utility/Functions';
import SelectDropdown from '../../Utility/SelectDropdown';
import { useFetch } from '../../../services/ApiService';

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

function CandidateFormNew({ candidateAadhar, candidateForm, setCandidateForm, finalPayload, setFinalPayload, setCurrent, agency_id, editMode, applicationData, appLoading }) {
    const { Search } = Input;
    const { Option } = Select;
    const navigate = useNavigate();
    const { fetchApi } = useFetch();

    const candidateFormRef = useRef();

    const [btnLoading, setBtnLoading] = useState(false);
    const [candidateData, setCandidateData] = useState(applicationData);
    const [aadharLoading, setAadharLoading] = useState(appLoading);

    const [previewImage, setPreviewImage] = useState([]);

    const [imageUrl, setImageUrl] = useState({});

    const [eduCerti, setEduCerti] = useState(false);
    const [expCerti, setExpCerti] = useState(false);
    const [trainingCerti, setTrainingCerti] = useState(false);
    const [otherCerti, setOtherCerti] = useState(false);

    const [eduCertiFile, setEduCertiFile] = useState({});
    const [expCertiFile, setExpCertiFile] = useState({});
    const [trainingCertiFile, setTrainingCertiFile] = useState({});
    const [otherCertiFile, setOtherCertiFile] = useState({});

    async function beforeUpload(file) {
        // console.log(file)
        const isJPG = ['image/jpeg'].includes(file.type) || ['image/png'].includes(file.type);
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
            message.error(`${file.name} is not a JPG/PNG File`);
            return isJPG;
        }
        else if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
            return isLt2M;
        }
        else {
            const base64Data = await getBase64(file);

            setPreviewImage([{
                uid: '-1',
                name: 'image.png',
                status: 'done',
                url: base64Data,
            }])
            setImageUrl(file);
            return false
        }

    }

    function beforeCertiUpload(file, type) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            message.error('File must be smaller than 10MB!');
            return isLt2M || Upload.LIST_IGNORE;
        }
        else {
            if (type === "edu") {
                setEduCertiFile(file);
            }
            if (type === "exp") {
                setExpCertiFile(file);
            }
            if (type === "training") {
                setTrainingCertiFile(file);
            }
            if (type === "other") {
                setOtherCertiFile(file);
            }
            return false
        }
    }

    const handleAadharSearch = (values) => {
        setCandidateData([]);

        if (values.aadhar_number.length > 12 || values.aadhar_number.length < 12) {
            message.error("Aadhar number should be 12 digits");
        }
        else {
            getCandidateData(values.aadhar_number);

        }
    }



    async function getCandidateData(no) {

        setAadharLoading(true);
        await fetchApi(`/api/application?aadhar_number=${no}`, 'GET').then(async res => {
            console.log(res);
            if (res.length > 0) {
                if (res[0].status === 'pending') {
                    await new Promise((resolve) => {
                        Modal.confirm({
                            title: 'An application is already in process',
                            content: 'An Application with this Aadhar Number is already in process. Please check the status on My Applications page.',
                            onOk: () => {
                                setAadharLoading(false);
                                setCandidateForm(false);
                                return
                            },
                            okText: 'Close',
                            onCancel: false,
                            cancelButtonProps: { style: { display: 'none' } }
                        })
                    })
                }
                else {
                    await new Promise((resolve) => {
                        Modal.confirm({
                            title: 'Aadhaar Number Already Exists',
                            content: 'This Aadhaar number is already registered in our system. Would you like to reapply using this number or enter a different Aadhaar number?',
                            onOk: () => {
                                console.log("Candidate Data ===> ", res)
                                setCandidateData(res);
                                setCandidateForm(true);
                                resolve();
                            },
                            okText: 'Re-Apply',
                            onCancel: () => {
                                setAadharLoading(false);
                                setCandidateForm(false);
                                return
                            }
                        })
                    })
                }

            }

            setCandidateForm(true);
        }).catch(err => {
            console.log(err);
        })

        setAadharLoading(false);
    }

    const handleCandidateData = async (values) => {
        setBtnLoading(true);
        const {
            recent_photograph, educational_certificates, experience_certificates, training_certificates, other_certificates, dob, ...restValues
        } = values;

        const { agency_name, ...restFinalPayload } = finalPayload;
        const payload = {
            ...restFinalPayload,
            ...restValues,
            'dob': isoFormatDate(values.dob),
            'image': imageUrl,
            'educational': eduCerti && eduCertiFile,
            'experience': expCerti && expCertiFile,
            'training': trainingCerti && trainingCertiFile,
            'other': otherCerti && otherCertiFile,
            'aadhar_number': candidateAadhar,
            //'status_id': 1,
            'agency_id': agency_id
        };
        console.log("Payload: ", payload);

        const formData = new FormData();
        Object.entries(payload).map(item => {
            item[1] &&
                formData.append(item[0], item[1]);
        });

        await fetchApi('/api/application', 'POST', formData).then(res => {
            message.success('Form has been successfully submitted');
            navigate('/application-list');
        }).catch(err => {
            console.log(err);
        })

        setBtnLoading(false);
    }



    useEffect(() => {

        /* if (editMode) {
            setCandidateForm(true);
     
        } */

    }, [editMode, applicationData])

    return (
        <>
            {/* {!editMode &&

                <div className='row justify-content-center'>
                    <div className="col-md-6">
                        <div className='h6 fw-semibold mb-1'>
                            Candidate Aadhar No

                        </div>

                        <div className='custom-search-wrapper'>
                            <Form
                                name="candidate-adhar-form"
                                layout="horizontal"
                                className='w-100'
                                onFinish={handleAadharSearch}
                                autoComplete='off'>

                                <div className='row g-0'>
                                    <div className='col-sm-9'>
                                        <Form.Item
                                            name="aadhar_number"
                                            className='mb-0 me-2'
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please enter 12 Digit Aadhar Number',
                                                    pattern: /^[0-9]{12}$/
                                                }
                                            ]}
                                        >
                                            <InputNumber controls={false} placeholder='Enter Aadhar Number' onChange={(value) => setCandidateAadhar(value)} />
                                        </Form.Item>
                                    </div>
                                    <div className='col-sm-3'>
                                        <Button type='primary' style={{ height: 50 }} size='large' htmlType='submit' loading={aadharLoading}>Submit</Button>
                                    </div>
                                </div>
                            </Form>

                            <Divider />
                        </div>
                    </div>
                </div>
            } */}
            <Skeleton loading={aadharLoading} active>

                <Form
                    name="candidate-form"
                    ref={candidateFormRef}
                    layout="vertical"
                    onFinish={handleCandidateData}
                    autoComplete='off'
                    initialValues={
                        candidateData.length > 0
                            ? {

                                candidate_name: candidateData[0].candidate_name,
                                employment_category_id: candidateData[0].employment_category_id,
                                states: candidateData[0].states,
                                job_trade_id: candidateData[0].job_trade_id,
                                qualification: candidateData[0].qualification,
                                years_of_experience: candidateData[0].years_of_experience,
                                dob: dayjs(candidateData[0].dob),
                                gender: candidateData[0].gender,
                            }
                            :
                            {}
                    }
                >
                    {candidateForm &&
                        <>
                            <div className="text-muted h6 my-3 text-center">
                                Application Type:
                                <Alert
                                    className='d-inline-block ms-2'
                                    message={candidateData.length > 0 ? "Re-Application" : "New"} type={candidateData.length > 0 ? 'warning' : 'info'}
                                />
                            </div>

                            <h3 className='line-through mb-3'><span>Candidate Information</span></h3>
                            <div className='row'>
                                <div className="col-md-8">

                                    <div className="row form-wrapper">

                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Candidate Name"
                                                name="candidate_name"
                                                // initialValue={candidateData.length > 0 ? candidateData[0].candidate_name : ''}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: ' Candidate Name is required',
                                                    },

                                                ]}
                                            >
                                                <Input placeholder='Enter Candidate Name' />
                                            </Form.Item>
                                        </div>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Date of Birth"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Date of Birth is required',
                                                    },
                                                    {
                                                        message: 'Candidate should be atleast 18 years old',
                                                        validator: (_, value) => {
                                                            var currentDate = dayjs();
                                                            if (currentDate.diff(value, 'year') < 18) {
                                                                return Promise.reject('Some message here');
                                                            }
                                                            else {
                                                                return Promise.resolve();
                                                            }
                                                            /* if (isAnswer !== "") {
                                                                return Promise.resolve();
                                                            } else {
                                                                return Promise.reject('Some message here');
                                                            } */
                                                        }
                                                    }
                                                ]}
                                                // initialValue={candidateData.length > 0 ? dayjs(candidateData[0].contract_expiration_date) : ''}
                                                name="dob"
                                            >
                                                <DatePicker />
                                            </Form.Item>
                                        </div>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Gender"
                                                name="gender"
                                                //initialValue={candidateData.length > 0 ? candidateData[0].employment_category : ''}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Gender is required',
                                                    },

                                                ]}
                                            >
                                                <Select placeholder='Select Gender'>
                                                    <Option value='male'>Male</Option>
                                                    <Option value='female'>Female</Option>
                                                    <Option value='other'>Other</Option>

                                                </Select>
                                            </Form.Item>
                                        </div>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Employment Category"
                                                name="employment_category_id"
                                            //initialValue={candidateData.length > 0 ? candidateData[0].employment_category : ''}

                                            >

                                                <SelectDropdown
                                                    //onSelect={handleInterviewerSelect}
                                                    size="large"
                                                    path='/api/employmentcategory'
                                                    placeholder="Select Trade"
                                                    fieldKey='name' />

                                            </Form.Item>
                                        </div>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Select State"
                                                name="states"
                                                //initialValue={candidateData.length > 0 ? candidateData[0].states : ''}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: ' State is required',
                                                    },

                                                ]}
                                            >
                                                <Select placeholder='Select Candidate State'>
                                                    <Option value="Andhra Pradesh">Andhra Pradesh</Option>
                                                    <Option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</Option>
                                                    <Option value="Arunachal Pradesh">Arunachal Pradesh</Option>
                                                    <Option value="Assam">Assam</Option>
                                                    <Option value="Bihar">Bihar</Option>
                                                    <Option value="Chandigarh">Chandigarh</Option>
                                                    <Option value="Chhattisgarh">Chhattisgarh</Option>
                                                    <Option value="Dadar and Nagar Haveli">Dadar and Nagar Haveli</Option>
                                                    <Option value="Daman and Diu">Daman and Diu</Option>
                                                    <Option value="Delhi">Delhi</Option>
                                                    <Option value="Lakshadweep">Lakshadweep</Option>
                                                    <Option value="Puducherry">Puducherry</Option>
                                                    <Option value="Goa">Goa</Option>
                                                    <Option value="Gujarat">Gujarat</Option>
                                                    <Option value="Haryana">Haryana</Option>
                                                    <Option value="Himachal Pradesh">Himachal Pradesh</Option>
                                                    <Option value="Jammu and Kashmir">Jammu and Kashmir</Option>
                                                    <Option value="Jharkhand">Jharkhand</Option>
                                                    <Option value="Karnataka">Karnataka</Option>
                                                    <Option value="Kerala">Kerala</Option>
                                                    <Option value="Madhya Pradesh">Madhya Pradesh</Option>
                                                    <Option value="Maharashtra">Maharashtra</Option>
                                                    <Option value="Manipur">Manipur</Option>
                                                    <Option value="Meghalaya">Meghalaya</Option>
                                                    <Option value="Mizoram">Mizoram</Option>
                                                    <Option value="Nagaland">Nagaland</Option>
                                                    <Option value="Odisha">Odisha</Option>
                                                    <Option value="Punjab">Punjab</Option>
                                                    <Option value="Rajasthan">Rajasthan</Option>
                                                    <Option value="Sikkim">Sikkim</Option>
                                                    <Option value="Tamil Nadu">Tamil Nadu</Option>
                                                    <Option value="Telangana">Telangana</Option>
                                                    <Option value="Tripura">Tripura</Option>
                                                    <Option value="Uttar Pradesh">Uttar Pradesh</Option>
                                                    <Option value="Uttarakhand">Uttarakhand</Option>
                                                    <Option value="West Bengal">West Bengal</Option>

                                                </Select>
                                            </Form.Item>
                                        </div>

                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Select Trade"
                                                name="job_trade_id"
                                                //initialValue={candidateData.length > 0 ? candidateData[0].job_trade : ''}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Trade is required',
                                                    },

                                                ]}
                                            >
                                                <SelectDropdown
                                                    //onSelect={handleInterviewerSelect}
                                                    size="large"
                                                    path='/api/jobtrade'
                                                    placeholder="Select Trade"
                                                    fieldKey='name' />

                                            </Form.Item>
                                        </div>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Candidate Qualification"
                                                name="qualification"
                                                //initialValue={candidateData.length > 0 ? candidateData[0].qualification : ''}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Candidate Qualification is required',
                                                    },

                                                ]}
                                            >
                                                <Input placeholder='Enter Candidate Qualification' />
                                            </Form.Item>
                                        </div>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Experience (in years)"
                                                name="years_of_experience"
                                                //initialValue={candidateData.length > 0 ? candidateData[0].years_of_experience : ''}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Experience is required',
                                                    },

                                                ]}
                                            >
                                                <InputNumber min={0.0} max={50.0} step={0.1} placeholder='Enter Candidate Experience' />
                                            </Form.Item>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-4">

                                    <Form.Item
                                        label="Recent photograph"
                                        name="recent_photograph"
                                        className='text-center'
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Recent photograph is required',
                                            },

                                        ]}
                                    >

                                        <div className='recent-photo'>
                                            <Upload
                                                className='w-100'
                                                listType="picture-card"
                                                fileList={previewImage}
                                                onRemove={() => {
                                                    setImageUrl([])
                                                    setPreviewImage([])
                                                }}
                                                beforeUpload={beforeUpload}
                                            >
                                                {
                                                    imageUrl.name === undefined && <UploadOutlined style={{ fontSize: 32 }} />
                                                }
                                            </Upload>
                                        </div>
                                    </Form.Item>

                                </div>
                                <div className='col-sm-12'>
                                    <h3 className='line-through mb-3'><span>Certificates</span></h3>
                                    <div className='row align-items-center'>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Availability of Educational Certificates"
                                                name="educational_certificates"
                                                className='flex-label-input'
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select an Option',
                                                    },

                                                ]}
                                                onChange={(e) => e.target.value === 'yes' ? setEduCerti(true) : setEduCerti(false)}
                                            >



                                                <Radio.Group>
                                                    <Radio value="yes"> Yes </Radio>
                                                    <Radio value="no"> No </Radio>
                                                </Radio.Group>


                                            </Form.Item>
                                        </div>
                                        {
                                            eduCerti && <div className='col-sm-6'>
                                                <Form.Item
                                                    label={false}
                                                    name="educational"

                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Education Certificate is required',
                                                        },

                                                    ]}
                                                >
                                                    <Upload
                                                        className='w-100' action="#"
                                                        beforeUpload={(file) => beforeCertiUpload(file, "edu")}
                                                        onRemove={() => setEduCertiFile([])}
                                                        maxCount={1}
                                                        multiple={false}
                                                        showUploadList={false}
                                                    >
                                                        <Button style={{ width: '100%' }}><UploadOutlined /> Select Educational Certificates</Button>
                                                    </Upload>

                                                    {
                                                        eduCertiFile.name !== undefined &&
                                                        <div className="mt-2 d-flex justify-content-between align-item-center bg-light py-1 px-2 rounded-2">
                                                            <span className='lh-base'>
                                                                <PaperClipOutlined />
                                                                {eduCertiFile.name}
                                                            </span>

                                                            <div>
                                                                <Button className='h-auto p-0 lh-base' danger type='link' icon={<DeleteOutlined />} onClick={() => setEduCertiFile({})}></Button>
                                                            </div>
                                                        </div>
                                                    }
                                                </Form.Item>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='col-sm-12'>
                                    <div className='row align-items-center'>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Availability of Experience Certificate"
                                                name="experience_certificates"
                                                className='flex-label-input'
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select an Option',
                                                    },

                                                ]}
                                                onChange={(e) => e.target.value === 'yes' ? setExpCerti(true) : setExpCerti(false)}
                                            >


                                                <Radio.Group>
                                                    <Radio value="yes"> Yes </Radio>
                                                    <Radio value="no"> No </Radio>
                                                </Radio.Group>

                                            </Form.Item>
                                        </div>
                                        {
                                            expCerti && <div className='col-sm-6'>
                                                <Form.Item
                                                    label={false}
                                                    name="experience"

                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Experience Certificate is required',
                                                        },

                                                    ]}
                                                >
                                                    <Upload
                                                        className='w-100' action="#"
                                                        beforeUpload={(file) => beforeCertiUpload(file, "exp")}
                                                        onRemove={() => setExpCertiFile([])}
                                                        maxCount={1}
                                                        showUploadList={false}
                                                    >
                                                        <Button style={{ width: '100%' }}><UploadOutlined /> Select Experiene Certificates</Button>
                                                    </Upload>

                                                    {
                                                        expCertiFile.name !== undefined &&
                                                        <div className="mt-2 d-flex justify-content-between align-item-center bg-light py-1 px-2 rounded-2">
                                                            <span className='lh-base'>
                                                                <PaperClipOutlined />
                                                                {expCertiFile.name}
                                                            </span>

                                                            <div>
                                                                <Button className='h-auto p-0 lh-base' danger type='link' icon={<DeleteOutlined />} onClick={() => setExpCertiFile({})}></Button>
                                                            </div>
                                                        </div>
                                                    }
                                                </Form.Item>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='col-sm-12'>
                                    <div className='row align-items-center'>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Availability of Taining Certificates"
                                                name="training_certificates"
                                                className='flex-label-input'
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select an Option',
                                                    },

                                                ]}
                                                onChange={(e) => e.target.value === 'yes' ? setTrainingCerti(true) : setTrainingCerti(false)}
                                            >
                                                <Radio.Group>
                                                    <Radio value="yes"> Yes </Radio>
                                                    <Radio value="no"> No </Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </div>
                                        {
                                            trainingCerti && <div className='col-sm-6'>
                                                <Form.Item
                                                    label={false}
                                                    name="training"

                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Training Certificate is required',
                                                        },

                                                    ]}
                                                >
                                                    <Upload
                                                        className='w-100' action="#"
                                                        beforeUpload={(file) => beforeCertiUpload(file, "training")}
                                                        onRemove={() => setTrainingCertiFile([])}
                                                        maxCount={1}
                                                        showUploadList={false}
                                                    >
                                                        <Button style={{ width: '100%' }}><UploadOutlined /> Select Training Certificates</Button>
                                                    </Upload>

                                                    {
                                                        trainingCertiFile.name !== undefined &&
                                                        <div className="mt-2 d-flex justify-content-between align-item-center bg-light py-1 px-2 rounded-2">
                                                            <span className='lh-base'>
                                                                <PaperClipOutlined />
                                                                {trainingCertiFile.name}
                                                            </span>

                                                            <div>
                                                                <Button className='h-auto p-0 lh-base' danger type='link' icon={<DeleteOutlined />} onClick={() => setTrainingCertiFile({})}></Button>
                                                            </div>
                                                        </div>
                                                    }
                                                </Form.Item>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='col-sm-12'>
                                    <div className='row align-items-center'>
                                        <div className='col-sm-6'>
                                            <Form.Item
                                                label="Availability of Other Certificates"
                                                name="other_certificates"
                                                className='flex-label-input'
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select an Option',
                                                    },

                                                ]}
                                                onChange={(e) => e.target.value === 'yes' ? setOtherCerti(true) : setOtherCerti(false)}
                                            >
                                                <Radio.Group>
                                                    <Radio value="yes"> Yes </Radio>
                                                    <Radio value="no"> No </Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </div>
                                        {
                                            otherCerti && <div className='col-sm-6'>
                                                <Form.Item
                                                    label={false}
                                                    name="other"

                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Other Certificate is required',
                                                        },

                                                    ]}
                                                >
                                                    <Upload
                                                        className='w-100' action="#"
                                                        beforeUpload={(file) => beforeCertiUpload(file, "other")}
                                                        onRemove={() => setOtherCertiFile([])}
                                                        maxCount={1}
                                                        showUploadList={false}
                                                    >
                                                        <Button style={{ width: '100%' }}><UploadOutlined /> Select Other Certificates</Button>
                                                    </Upload>

                                                    {
                                                        otherCertiFile.name !== undefined &&
                                                        <div className="mt-2 d-flex justify-content-between align-item-center bg-light py-1 px-2 rounded-2">
                                                            <span className='lh-base'>
                                                                <PaperClipOutlined />
                                                                {otherCertiFile.name}
                                                            </span>

                                                            <div>
                                                                <Button className='h-auto p-0 lh-base' danger type='link' icon={<DeleteOutlined />} onClick={() => setOtherCerti({})}></Button>
                                                            </div>
                                                        </div>
                                                    }
                                                </Form.Item>
                                            </div>
                                        }
                                    </div>

                                </div>
                            </div>
                        </>
                    }
                    <div className='step-btns-navigation mt-3'>
                        <Button type="secondary" onClick={() => setCurrent(0)} className='px-5' size="large">Back</Button>
                        <Button disabled={!candidateForm} loading={btnLoading} type="primary" className='px-5' htmlType="submit" size="large">Submit</Button>
                    </div>
                </Form>
            </Skeleton>
        </>
    )
}

export default CandidateFormNew